import { render, staticRenderFns } from "./VehiclesRegoSearch.vue?vue&type=template&id=da394076&scoped=true&"
import script from "./VehiclesRegoSearch.vue?vue&type=script&lang=ts&"
export * from "./VehiclesRegoSearch.vue?vue&type=script&lang=ts&"
import style0 from "./VehiclesRegoSearch.vue?vue&type=style&index=0&id=da394076&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da394076",
  null
  
)

export default component.exports